import React, { PropTypes } from 'react';
import ObjectRelObjectsObject from './Object'
import RelSectionTemplate from '../../shared/RelSectionTemplate';

const ObjectRelObjects = ({ object, title }) => {
    let entries = [];
    if (!!object.ObjObjects && !!object.ObjObjects.edges && object.ObjObjects.edges.length) {
        entries = object.ObjObjects.edges.map(edge => (
            <ObjectRelObjectsObject key={ edge.node.ObjId } object={ edge.node } />
        ));
    }

    return (
        entries.length ? (
            <RelSectionTemplate title={title}>
                <ul className="object-list">
                    { entries }
                </ul>
            </RelSectionTemplate>
        ) : <div></div>
    )
};

ObjectRelObjects.propTypes = {
    object: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
};

export default ObjectRelObjects;


// WEBPACK FOOTER //
// ./app/components/Object/RelObjects/ObjectRelObjects.jsx